import {
  createPercentFormatter,
  createIntFormatter,
  createDecimalFormatter,
  currencyFormatter
} from '../../../../utils/formatter/formatter'

export const pctFmt = createPercentFormatter({ minimumFractionDigits: 0, maximumFractionDigits: 0 });
export const intFmt = createIntFormatter();
export const decFmt = createDecimalFormatter({ minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtBrl = (value) => value != null ? currencyFormatter.format(value) : null;
export const fmtInt = (value) => value != null ? intFmt.format(value) : null;
export const fmtMultiplier = (value) => value != null ? `${decFmt.format(value)}x` : null;